import AgencyCodeAdmin from "./agencyCodes"

export { default as AgencyCodesPanel } from "./agencyCodes.panel"
export default AgencyCodeAdmin
